import React from 'react';

function RenderBrowser(props) {
  const { children } = props;
  return <div className="app-body-center col-12 p-4 bg-white shadow-sm">{children}</div>;
}

export default RenderBrowser;
